import { request } from './client'
import type { LoginResponse } from './contracts'

export function login(username: string, password: string, deviceId: string): Promise<LoginResponse> {
  return request<LoginResponse>('/auth/login', {
    method: 'POST',
    anonymous: true,
    body: { username, password, deviceId },
  })
}

export function logout(): Promise<void> {
  return request<void>('/auth/logout', { method: 'POST' })
}
